import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logBrowserBackButton } from '@/telemetry/telemetryEvents';
import { logDev as debugLog } from '@/logging/devConsole';

// Map routes to screen names for telemetry
const ROUTE_TO_SCREEN_MAP: Record<string, string> = {
  '/frontlinebyod': 'WelcomeScreen',
  '/frontlinebyod/device-selection': 'DeviceSelection',
  '/frontlinebyod/auth-setup': 'AuthenticatorSetupScreen',
  '/frontlinebyod/company-portal-install': 'CompanyPortalInstall',
  '/frontlinebyod/app-download': 'AppDownloadScreen',
  '/frontlinebyod/retry': 'RetryScreen',
  '/frontlinebyod/error': 'ErrorScreen',
  '/frontlinebyod/completion': 'CompletionScreen',
  '/frontlinebyod/feedback-thanks': 'FeedbackThanksScreen',
};

/**
 * Hook to track browser back/forward button usage
 * Detects popstate events (browser navigation) and logs to UserBI
 */
export function useBrowserBackTracking() {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      // Use setTimeout to ensure location has updated
      setTimeout(() => {
        const screenName = ROUTE_TO_SCREEN_MAP[location.pathname] || location.pathname;
        debugLog('[BrowserBackTracking] Browser back/forward detected, navigated to:', screenName);
        logBrowserBackButton(screenName);
      }, 0);
    };

    // Listen for browser back/forward navigation
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname]);
}
